"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_CONSTAMNTS = exports.PATHS = void 0;
exports.PATHS = {
    overView: '',
    fe: 'fe',
    activeList: 'active',
    vendorlist: 'vendor',
    cashDeletion: 'cashDeletion',
    cclist: 'cc',
    createNotification: 'createnotification',
    allFeList: 'list',
    draftedFeList: 'drafted',
    feExisted: 'exited',
    feRejected: 'rejected',
    feDetails: 'details',
    payroll: 'payroll',
    payrun: 'payrun',
    payroleHistory: 'history',
    viewpayrole: 'viewpayrole',
    leaveTraking: 'leave',
    trackFe: 'track',
    feKpis: 'kpis',
    feProfileDetails: 'profiledetails',
    feAuditHistory: 'auditHistory',
    feRegistration: 'New',
    feReplaceRegistration: 'Replace',
    feOnLeave: 'onleave',
    feApprovalPending: 'approvalpending',
    slotBlocking: 'slotblocking',
    editFE: 'edit',
    addFE: 'add',
    addSlot: 'addslot',
    invetoryPending: 'inventorypending',
    pagenotFound: 'pagenotfound',
    badRequest: 'badrequest',
    feInActiveList: 'inactive',
    vendorProfileDetials: 'profiledetails',
    userMasters: 'usermaster',
    feMasters: 'femaster',
    ccMasters: 'ccmaster',
    role_management: 'role',
    addNewRole: 'addrole',
    editRole: 'edit',
    userManagement: 'user',
    addUser: 'adduser',
    userProfileDetails: 'details',
    userDetials: 'profile',
    vendormanagement: 'vendor',
    createVendor: 'new',
    editVendor: 'editvendor',
    approvals: 'approvalmanagement',
    notificationManagement: 'notifications',
    audit: 'audit',
    addAudit: 'addAudit',
    createAudit: 'createAudit',
    levelOneApprovalList: 'levelonelist',
    approveProfileDetails: 'vendor-details',
    feLevelOneDetails: 'level1-details',
    feLevelTwoDetails: 'level2-details',
    levelOnePendingApproval: 'levelOnePendingApproval',
    levelTwoPendingApproval: 'levelTwoPendingApproval',
    reviewAudit: 'review',
    sampleTracking: 'sampletracking',
    masterbox_basicDeatils: 'masterbox',
    sampleTraking_basicDetails: 'basicdetails',
    auditDetails: 'auditdetails',
    assignAudit: 'AssignAudit',
    createUser: 'createUser',
    vendor: 'vendor',
    ETRFList: 'etrf',
    ETRF_Profile: 'profile',
    ETRF_details: 'etrf-details',
    controlTower: 'controlTower',
    newDashboard: 'NewDashboard',
    controlCenter: 'controlCenter',
    autoRoutingDashboard: 'autoRoutingDashboard',
    sampleList: 'sampleList',
    controCenterFedetails: 'feDetails',
    controlDashboard: 'controldashboard',
    controlTowerRouting: 'ControlTowerRouting',
    reports: 'reports',
    cahCollectionReport: 'cahCollectionReport',
    baggingLifeCycle: 'baggingLifeCycle',
    baggingLifeCycleReport: 'baggingLifeCycleReport',
    baggingLifeCycleReportLite: 'baggingLifeCycleReportLite',
    autoRoutingReport: 'autoRoutingReport',
    cashPendingReport: 'cashPendingReport',
    cashDeletionLogs: 'cashDeletionLogs',
    clientSlotwiseProductivityReports: 'clientSlotwiseProductivity',
    feAttendanceReport: 'feAttendanceReport',
    successfulVisits: 'successfulVisits',
    nothingTopickup: 'nothingTopickup',
    outstationMasterboxReport: 'outstationMasterboxReport',
    rLabtoPLabIntercityReport: 'rLabtoPLabIntercityReport',
    rLabtoPLabShipmentReport: 'rLabtoPLabShipmentReport',
    otherDocuments: 'otherdoc',
    otherDocsProfile: 'otherDocsProfile',
    otherDocsDetails: 'otherDocsDetails',
    editAudit: 'editAudit',
    active_vendors: 'active',
    draft_vendors: 'draft',
    exit_vendors: 'exited',
    vendor_pending_approval: 'pendingapproval',
    vendor_level2: 'level2approval',
    vendor_reject: 'reject',
    reports2: 'reports2',
    reports3: 'reports3',
    mastersData: 'mastersData',
    masterbagging: 'bagging',
    centerCityMappingMasters: 'centerCityMappingMasters',
    feLabMasters: 'feLabMasters',
    labMaster: 'labMaster',
    dynamicRoutingMasters: 'dynamicRoutingMasters',
    preciousSamples: 'precious_samples',
    heatMaps: 'heatmaps',
    onDemandRequest: 'onDemandRequest',
    assignRequest: 'assignRequest',
    totalActiveClients: 'totalActiveclients',
    assignRoute: 'assignRoute',
    misReport: 'misreports',
    tab: 'tab',
    editslotFE: 'edit',
    ViewFeSlot: 'view',
    feRoute: 'feRoute',
    AddVisits: 'AddVisits',
    Visits: 'Visits',
    VisitsList: 'VisitsList',
    resetPswd: 'reset',
    forgotPswd: 'forgotPassword',
    VisitDetails: 'VisitDetails',
    SSO_LOGIN: 'sso',
    vendorLevelOneDetails: 'vendorlevel1-details',
    vendorLevelTwoDetails: 'vendorlevel2-details',
    cashDeletionLevelOneDetails: 'cashDeletionlevel1-details',
    cashDeletionLevelTwoDetails: 'cashDeletionlevel2-details',
    cre: 'cre',
    creOnboardingInProgress: 'onboardingInProgress',
    creExit: 'exited',
    creNewApprovalPending: 'approvalPending',
    creInactive: 'inActive',
    creRejected: 'rejected',
    ax_cash_receieving: 'synclogs',
    cash_receiving: 'cashreceiving',
    lab_receieving: 'labreceiving',
    ax_cash_receieving_details: 'ax_cash_receieving_details',
    ROUTE_MAP: 'routemap',
    POLYLINE_MAP: 'polylinemap',
    MYREPORTS: 'myReports',
    SYSTEM_GENERATED: 'systemGeneratedReports',
    userProfile: 'profile',
    ccworkinghourslist: 'ccworkinghourslist',
    addCCSlot: 'addCCSlot',
    changePassword: 'changePassword',
    route_planner: 'routeplanner',
    User_Logistics: 'UserLogistics',
    Create_User: 'CreateUser',
    Assign_Region: 'assignRegion',
    Edit_Region: 'editRegion',
    approvals_route_planner: 'approvaleplanner',
    create_route_planner: 'edit',
    route_planner_details: 'detials',
    view_route_planner: 'view',
    route_planner_changes_list: 'list',
    route_planner_list: 'routePlanerList',
    route_planner_approved_details: 'approveddetails',
    master_box_tracking: 'masterBoxTracking',
    master_box_details: 'details',
    create_hub_slot: 'createHub',
    edit_hub_slot: 'editTimeSlot',
    LabMasterlist: 'LabMasterlist',
    AddLabMaster: 'addLabMaster',
    hubMasterList: 'hubMasterList',
    visitsReport: 'visitsReport',
    allReports: 'allReports',
    assignedCompletedReports: 'assignedCompletedReports',
    masterBoxtracking: 'masterbox',
    masterBoxDetails: 'BagDetails',
    eventPerformance: 'eventPerformance',
    unTaggedClientsToCC: 'untaggedclients',
    Masterboxtower: 'Masterboxtower',
    ShipmentTower: 'ShipmentTower',
    sso_ondemandRequest: 'sso',
    sso_ondemandRequest_create: 'create',
    region_create: 'CreateRegion',
    user_region: 'userRegion',
    region_mapping: 'regionMapping',
    region_listing: 'regionListing',
    shipment_tracking: 'shipmentTracking',
    shipment_details: 'shipmentDetails',
    intracity_tat_report: 'intracitytat',
    intracity_ontime_pickup: 'intracityontimepickup',
    intracity_labHandOver: 'intracitylabhandover',
    r_lab_to_p_lab: 'rlabtoplab',
    outStationMasterBox: 'outstationmasterbox',
    intracity_tat_filters: 'intracitytatfilters',
    intracity_tat_graph_list: 'intracitytatgraphlist',
    on_time_pickup: 'onTimePickFilters',
    on_time_pickup_list: 'onTimePickList',
    fe_traking_list: 'felist',
    fe_traking_details: 'details',
    shipment_list: 'ShipmentList',
    shipment_create: 'ShipmentCreate',
    shipment_edit: 'ShipmentEdit',
    shipment_view: 'ShipmentView',
    labHandoverTrend: 'labHandoverTrend',
    orc_listing: 'orc',
    orc_active_listing: 'active',
    orc_level1_listing: 'levelone',
    orc_leve2_listing: 'leveltwo',
    orc_rejected_listing: 'rejected',
    create_orc: 'createorc',
    edit_orc: 'editorc',
    orc_profile_details: 'details',
    scf_listing: 'scf',
    scf_active_listing: 'active',
    scf_level1_listing: 'levelone',
    scf_leve2_listing: 'leveltwo',
    scf_rejected_listing: 'rejected',
    create_scf: 'createscf',
    edit_scf: 'editscf',
    scf_profile_details: 'details',
    ultra_static_list: "ultraStaticList",
    create_ultra_static: 'addUltraStatic',
    edit_ultra_static: 'editUltraStatic',
    PartialTransfer: 'partialTransfer',
    OTPManagement: 'otpManagement',
    system_configuration: 'systemConfiguration'
};
var MENU_LABEL_AND_PATHS_RESTRICTED_BY_SSO = [
    {
        id: 13,
        fieldName: 'Sample Tracking',
        path: "".concat(exports.PATHS.sampleTracking),
        description: 'icon',
        icon: 'icon-moped',
    },
];
exports.ROUTE_CONSTAMNTS = {
    PATHS: exports.PATHS,
    MENU_LABEL_AND_PATHS_RESTRICTED_BY_SSO: MENU_LABEL_AND_PATHS_RESTRICTED_BY_SSO,
};
exports.default = exports.ROUTE_CONSTAMNTS;
